import { Injectable } from '@angular/core';
import { HG_TOOLTIP_ARROW_STYLE, HTML_DISPLAY_BLOCK, HTML_DISPLAY_NONE } from './lightning-chart-ui-constants';
import { LightningChartBuilder } from './lightning-chart-builder';


@Injectable({
    providedIn: 'root'
  })
export class LightningChartsTooltipFactory {

    public arrowShow(arrow: HTMLDivElement, isVisible: boolean) {
        arrow.style.display = isVisible ? HTML_DISPLAY_BLOCK : HTML_DISPLAY_NONE;
    }

    public createArrow(container: HTMLElement) {
        const arrow = document.createElement('div');

        LightningChartBuilder.applyStyles(arrow, HG_TOOLTIP_ARROW_STYLE);

        container.append(arrow);

        return arrow;
    }

    public arrowStyle(arrow: HTMLDivElement, position: {x: number, y: number}, color: string) {
        arrow.style.left = `${Math.round(position.x)}px`;
        arrow.style.top = `${Math.round(position.y)}px`;
        arrow.style.backgroundColor = `${color}`;
    }

}
